export default {
  permissions(state) {
    return state.permissions
  },
  activePermissionsMap(state) {
    return state.activePermissionsMap
  },
  groupPermissions(state) {
    return state.groupPermissions
  },
  activeGroupPermissionsMap(state) {
    return state.activeGroupPermissionsMap
  },
  permissionsPilkiPro(state) {
    return state.permissionsPilkiPro
  },
  activePermissionsMapPilkiPro(state) {
    return state.activePermissionsMapPilkiPro
  },
  groupPermissionsPilkiPro(state) {
    return state.groupPermissionsPilkiPro
  },
  activeGroupPermissionsMapPilkiPro(state) {
    return state.activeGroupPermissionsMapPilkiPro
  },
}
